

const Peg = ({pegColor, id, selectedColor, handleClick}) => {
  const pegStyle = {
    backgroundColor: pegColor,
    width: '4rem',
    height: '4rem',
    borderRadius: '4rem',
    marginRight: '0.5rem'
  };

  return (
    <div id={id} className={`${(id.charAt(0) == 0 && pegColor === selectedColor) ? 'pegSelected' : 'peg'}`} 
        style={pegStyle} onClick={handleClick}></div>
  )
}

export default Peg;
